import { isEqual } from 'lodash-es'
import AIMEOS_GETTER_TYPES from '@/js/plugins/store/modules/aimeos/getter-types'

export const basketCustomerRefAndCommentCompare = ({ getters }) => {
  return (
    getters[AIMEOS_GETTER_TYPES.REFERENCE] === getters[AIMEOS_GETTER_TYPES.BASKET_REFERENCE] &&
    isEqual(
      getters[AIMEOS_GETTER_TYPES.CLIENT_DATA],
      getters[AIMEOS_GETTER_TYPES.BASKET_CLIENT_DATA],
    )
  )
}
